module.exports = {
  'en': {
    'HRRC21P1': {
      '0': 'General Data',
      '10': 'Applicant No.',
      '20': 'Title',
      '30': 'Nickname',
      '40': 'Name',
      '50': 'LastName',
      '60': 'Applied Date',
      '70': 'Position applied',
      '80': 'Branch Applied',
      '90': 'Yes',
      '100': 'No',
      '110': 'Expected Income (P.M)',
      '120': 'Currency',
      '130': 'Source of Information',
      '140': 'File Image',
      '150': 'Own Car',
      '160': 'Yes',
      '170': 'No',
      '180': 'Ever Been Suspended ?',
      '190': 'Yes',
      '200': 'No',
      '1001': 'Applicant\'s Information',
      '1080': 'Personal Data',
      '1085': 'Gender',
      '1090': 'Male',
      '1095': 'Female',
      '1100': 'Height',
      '1105': 'Weight',
      '1110': 'Birth Date',
      '1115': 'Place of Birth',
      '1120': 'Nationality',
      '1135': 'Marital Status',
      '1140': 'Military Service',
      '1145': 'I.D. Card No.',
      '1150': 'Place of Issue',
      '1165': 'English',
      '1170': 'Record Job Application Data',
      '1175': 'Language',
      '1180': 'Description',
      '1185': '2nd  Position Applied'
    },
    'HRRC21P10': {
      '0': 'Reference',
      '10': 'Seq.No.',
      '20': 'Name',
      '30': 'Position',
      '40': 'Contact Address',
      '50': 'Occupation',
      '60': 'Ref.Type',
      '70': 'Company',
      '80': 'Telephone',
      '90': 'E-mail Address',
      '100': 'Comments',
      '110': 'Last Update Date',
      '120': 'By'
    },
    'HRRC21P11': {
      '0': 'Skill Data',
      '10': 'Type of Skill',
      '20': 'Description',
      '30': 'Skill Level',
      '40': 'Yrs. of experience',
      '50': 'Last Update Date',
      '60': 'By'
    },
    'HRRC21P12': {
      '0': 'Training Data',
      '10': 'Seq.',
      '20': 'Description',
      '30': 'Training date',
      '40': 'Place',
      '50': 'Organized by',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'HRRC21P13': {
      '0': 'Competency',
      '10': 'Competency',
      '20': 'Description',
      '30': 'Level',
      '40': 'Full Score',
      '50': 'Score',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'HRRC21P14': {
      '0': 'Document',
      '5': 'Seq.No',
      '6': 'Document Type',
      '10': 'Document Name',
      '20': 'File Document',
      '30': 'Last Update Date',
      '40': 'By',
      '50': 'Seq.No',
      '60': 'Document Type',
      '70': 'Receive Date',
      '80': 'End Date',
      '90': 'Document No.',
      '100': 'File Document',
      '110': 'Description Note'
    },
    'HRRC21P15': {
      '0': 'Other Information',
      '10': 'Reason for your application.',
      '20': 'When will you be able to joint company',
      '30': 'Have you ever been in civil servant service ?',
      '40': 'Last Position',
      '50': 'Department',
      '60': 'Have you ever passed  military service ?',
      '70': 'Reason of exemption',
      '80': 'Have you been ordained ?',
      '90': 'From',
      '100': 'To',
      '110': 'Do you have any personal illness',
      '120': 'Specify',
      '130': 'Symptom',
      '140': 'Have you ever severely ill ?',
      '150': 'Specify',
      '160': 'Have you ever been arrested or taken in custody ?',
      '170': 'Specify',
      '180': 'Have you know anybody in the company ?',
      '190': 'Specify',
      '200': 'Have you been applied for a job in this company ?',
      '210': 'Specify position/period',
      '220': 'Can you  work in upcountry ?',
      '230': 'Hobbies',
      '240': 'No',
      '250': 'Yes',
      '260': 'No',
      '270': 'Yes',
      '280': 'No',
      '290': 'Yes'
    },
    'HRRC21P150': {
      '0': 'Employment Preference',
      '10': 'Career Object',
      '20': 'Availability',
      '21': 'Immediately',
      '22': 'After',
      '23': 'Within',
      '30': 'Day(s)',
      '40': 'Preferred Job Functions',
      '50': 'Preferred Locations',
      '60': 'Travel upcountry',
      '70': 'Travel overseas'
    },
    'HRRC21P16': {
      '0': 'Emergency Contact Person',
      '10': 'Emergency Contact Person',
      '20': 'Name',
      '30': 'Relationship',
      '40': 'Contact Address',
      '50': 'Zip Code',
      '60': 'Telephone',
      '70': 'E-mail Address',
      '80': 'Fax No.'
    },
    'HRRC21P17': {
      '0': 'Addition Data',
      '10': 'Field',
      '20': 'Description',
      '30': 'Type of data',
      '40': 'Value',
      '50': 'Last Update Date',
      '60': 'By'
    },
    'HRRC21P18': {
      '0': 'Detail Blacklisted Employee',
      '10': 'ID.Card No.',
      '20': 'Title Name',
      '30': 'Name',
      '40': 'Last Name',
      '50': 'gender',
      '60': 'Id.Employee',
      '70': 'Applicant No.',
      '80': 'Birth Date',
      '90': 'Age',
      '100': 'Yrs.',
      '110': 'Month',
      '120': 'Passport No.',
      '130': 'Image file',
      '140': 'Detail of previous employment',
      '150': 'Employer\'s name',
      '160': 'Department Last',
      '170': 'Last position',
      '180': 'hired Date',
      '190': 'Resigned date',
      '200': 'Reason of termination'
    },
    'HRRC21P19': {
      '0': 'Other abilities',
      '10': 'activities during education',
      '20': 'Proficiency',
      '30': 'Computer Skills',
      '40': 'Typing skills Thai',
      '50': 'Words / Minute',
      '60': 'Typing skills in English',
      '70': 'Words / Minute',
      '80': 'Language ability',
      '90': 'Listen',
      '100': 'Speak',
      '110': 'Read'
    },
    'HRRC21P2': {
      '0': 'Applicant Status',
      '10': 'Status',
      '20': 'As.of Date',
      '30': 'Assigned to Pr.No.',
      '40': 'Position',
      '50': 'Emp. I.D.',
      '60': 'Detail of Applicant Evaluation',
      '70': 'Suitable Position is',
      '80': 'Evaluated  by',
      '90': 'Department',
      '100': 'Date',
      '110': 'Rejected Reason',
      '120': 'Add to Backlist',
      '130': 'Yes',
      '140': 'No',
      '150': 'Comments',
      '160': 'Assign to PR. No.'
    },
    'HRRC21P20': {
      '0': 'Interview/Result',
      '10': 'Interview / Test',
      '20': 'Request No.',
      '30': 'Position',
      '40': 'Operate Date',
      '50': 'Result',
      '60': 'Reviewed By',
      '70': 'Review Date',
      '80': 'Interview/Test Information',
      '90': 'Seq',
      '100': 'Appointment Type',
      '110': 'Appointment Date',
      '120': 'Full Score',
      '130': 'Score'
    },
    'HRRC21P3': {
      '0': 'Applied History',
      '10': 'Applied Date',
      '20': 'Applied for Position',
      '30': 'Main Position',
      '40': '2nd Position',
      '50': 'Applicant No.',
      '60': 'Applicant Status',
      '70': 'Assign to PR.No.',
      '80': 'Position',
      '90': 'last action date',
      '100': 'Score %',
      '110': 'Result'
    },
    'HRRC21P4': {
      '0': 'Personal Data',
      '10': 'Birth Date',
      '20': 'Place of Birth',
      '30': 'Gender',
      '31': 'Male',
      '32': 'Female',
      '40': 'I.D. Card No.',
      '50': 'Issued at',
      '60': 'Expired Date',
      '70': 'Province',
      '80': 'Marital Status',
      '90': 'Military Service',
      '100': 'Tax ID',
      '110': 'Social Security ID',
      '120': 'Blood Group',
      '130': 'Weight',
      '140': 'Hight',
      '150': 'Relegion',
      '160': 'Race',
      '170': 'Nationality',
      '180': 'Driving License',
      '190': 'ID License',
      '200': 'Expire Date',
      '210': 'Passport  / Work permit Details',
      '220': 'Passport Number',
      '230': 'Expire Date',
      '240': 'Work Permit Number',
      '250': 'Work Permit Issue Date',
      '260': 'Work Permit Expire Date'
    },
    'HRRC21P5': {
      '0': 'Contact Address',
      '10': 'Contact Address',
      '20': 'Contact Address',
      '30': 'Address',
      '40': 'District',
      '50': 'Ampher',
      '60': 'Province',
      '70': 'Country',
      '80': 'Mobile Phone',
      '90': 'Zip Code',
      '100': 'E-mail Address',
      '110': 'Registration l Address',
      '120': 'Address',
      '130': 'District',
      '140': 'Ampher',
      '150': 'Province',
      '160': 'Country',
      '170': 'Zip Code',
      '180': 'Email',
      '190': 'Home Phone',
      '200': 'Mobile Phone',
      '210': 'Home Phone'
    },
    'HRRC21P6': {
      '0': 'Parent\'s Information',
      '10': 'Parent\'s Information',
      '20': 'Father\'s Information',
      '30': 'Name',
      '40': 'Nationality',
      '50': 'Relegion',
      '60': 'Occupation',
      '70': 'Mother\'s Information',
      '80': 'Name',
      '90': 'Nationality',
      '100': 'Relegion',
      '110': 'Occupation',
      '120': 'Spouse Information',
      '130': 'Name',
      '140': 'Citizen i.d',
      '150': 'Occupation',
      '160': 'Birth Date',
      '170': 'Company'
    },
    'HRRC21P7': {
      '0': 'Education Data',
      '10': 'Seq.',
      '20': 'Education Level',
      '30': 'Type of Degree',
      '40': 'Major',
      '50': 'Institute',
      '60': 'County',
      '70': 'Last Update Date',
      '80': 'By'
    },
    'HRRC21P8': {
      '0': 'Children Data',
      '10': 'Seq. No',
      '20': 'Children\'s Name',
      '30': 'Birth Date',
      '40': 'Gender',
      '50': 'Education',
      '60': 'Last Update Date',
      '70': 'By'
    },
    'HRRC21P9': {
      '0': 'Former Employer',
      '10': 'Seq.',
      '20': 'Company Name',
      '30': 'Location',
      '40': 'Position',
      '50': 'Start Date',
      '60': 'Resigned Date',
      '70': 'Last Update Date',
      '80': 'By'
    }
  },
  'th': {
    'HRRC21P1': {
      '0': 'ข้อมูลทั่วไป',
      '10': 'เลขที่ใบสมัคร',
      '20': 'คำนำหน้า',
      '30': 'ชื่อเล่น',
      '40': 'ชื่อ',
      '50': 'นามสกุล',
      '60': 'วันที่สมัคร',
      '70': 'ตำแหน่งที่สมัคร',
      '80': 'ระบุสาขาที่สมัคร',
      '90': 'ระบุ',
      '100': 'ไม่ระบุ',
      '110': 'เงินเดือนที่คาดหวัง',
      '120': 'สกุลเงิน',
      '130': 'แหล่งที่ทราบข่าว',
      '140': 'ชื่อรูป',
      '150': 'มีรถยนต์ส่วนตัว',
      '160': 'มี',
      '170': 'ไม่มี',
      '180': 'เคยผ่านงานหรือไม่ ?',
      '190': 'เคย',
      '200': 'ไม่เคย',
      '1001': 'ข้อมูลใบสมัคร',
      '1080': 'ข้อมูลส่วนตัว',
      '1085': 'เพศ',
      '1090': 'ชาย',
      '1095': 'หญิง',
      '1100': 'ส่วนสูง',
      '1105': 'น้ำหนัก',
      '1110': 'วันเกิด',
      '1115': 'สถานที่เกิด',
      '1120': 'เชื้อชาติ',
      '1135': 'สถานภาพการสมรส',
      '1140': 'สถานะทหาร',
      '1145': 'เลขที่บัตรประชาชน',
      '1150': 'ออกบัตรที่',
      '1165': 'English',
      '1170': 'ข้อมูลใบสมัครพนักงาน',
      '1175': 'ภาษา',
      '1180': 'รายละเอียด',
      '1185': 'ตำแหน่งสำรอง'
    },
    'HRRC21P10': {
      '0': 'บุคคลอ้างอิง',
      '10': 'ลำดับที่',
      '20': 'ชื่อ',
      '30': 'ตำแหน่ง',
      '40': 'ที่อยู่',
      '50': 'อาชีพ',
      '60': 'ความสัมพันธ์',
      '70': 'บริษัท',
      '80': 'โทรศัพท์',
      '90': 'E-mail Address',
      '100': 'หมายเหตุ',
      '110': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '120': 'โดย'
    },
    'HRRC21P11': {
      '0': 'ข้อมูลความชำนาญ',
      '10': 'ประเภทความสามารถ',
      '20': 'รายละเอียด',
      '30': 'ระดับความชำนาญ',
      '40': 'ประสบการณ์(ปี)',
      '50': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '60': 'โดย'
    },
    'HRRC21P12': {
      '0': 'ข้อมูลการฝึกอบรม',
      '10': 'ลำดับที่',
      '20': 'รายละเอียด',
      '30': 'วันที่เข้าอบรม',
      '40': 'สถานที่',
      '50': 'จัดโดย',
      '60': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '70': 'โดย'
    },
    'HRRC21P13': {
      '0': 'ความสามารถ',
      '10': 'ความสามารถ',
      '20': 'รายละเอียด',
      '30': 'ระดับ',
      '40': 'คะแนนเต็ม',
      '50': 'คะแนนที่ได้',
      '60': 'แก้ไขครั้งสุดท้าย',
      '70': 'โดย'
    },
    'HRRC21P14': {
      '0': 'เอกสารส่วนตัว',
      '5': 'ลำดับที่',
      '6': 'ประเภทเอกสาร',
      '10': 'ชื่อเอกสาร',
      '20': 'ชื่อไฟล์',
      '30': 'แก้ไขครั้งสุดท้าย',
      '40': 'โดย',
      '50': 'ลำดับที่',
      '60': 'ประเภทเอกสาร',
      '70': 'วันที่รับเอกสาร',
      '80': 'วันที่หมดอายุ',
      '90': 'เลขที่เอกสาร',
      '100': 'ชื่อไฟล์',
      '110': 'รายละเอียดอื่นๆ'
    },
    'HRRC21P15': {
      '0': 'ข้อมูลอื่นๆ',
      '10': 'วัตถุประสงค์ที่มาสมัคร',
      '20': 'เริ่มงานได้เมื่อ',
      '30': 'เคยรับราชการ ?',
      '40': 'ตำแหน่งสูงสุด',
      '50': 'หน่วยงาน',
      '60': 'เคยผ่านการเกณฑ์ทหาร ?',
      '70': 'ได้รับการยกเว้นเพราะ',
      '80': 'เคยอุปสมบท ?',
      '90': 'จาก',
      '100': 'ถึง',
      '110': 'มีโรคประจำตัว ?',
      '120': 'ระบุโรค',
      '130': 'อาการ',
      '140': 'เคยป่วยหนัก ?',
      '150': 'ระบุรายละเอียด',
      '160': 'เคยถูกฟ้องถูกจับ ?',
      '170': 'ระบุข้อกล่าวหา',
      '180': 'มีญาติหรือคนรู้จักในบริษัท ?',
      '190': 'ระบุชื่อ - สกุล',
      '200': 'เคยสมัครงานกับบริษัทนี้มาก่อน ?',
      '210': 'ระบุตำแหน่ง/ช่วงเวลา',
      '220': 'ทำงานประจำต่างจังหวัด ?',
      '230': 'งานอดิเรก',
      '240': 'ไม่เคย',
      '250': 'เคย',
      '260': 'ไม่มี',
      '270': 'มี',
      '280': 'ไม่ได้',
      '290': 'ได้'
    },
    'HRRC21P150': {
      '0': 'Employment Preference',
      '10': 'เป้าหมาย',
      '20': 'เริ่มปฏิบัติงาน',
      '21': 'ปฏิบัติงานได้ทันที',
      '22': 'เริ่มหลังวันที่',
      '23': 'ภายใน',
      '30': 'วัน',
      '40': 'ลักษณะงานที่ต้องการ',
      '50': 'สถานที่ปฏิบัติงานที่ต้องการ',
      '60': 'ปฏิบัติงานต่างจังหวัด',
      '70': 'ปฏิบัติงานต่างประเทศ'
    },
    'HRRC21P16': {
      '0': 'บุคคลที่ติดต่อยามฉุกเฉิน',
      '10': 'บุคคลที่ติดต่อยามฉุกเฉิน',
      '20': 'ชื่อ',
      '30': 'ความสัมพันธ์',
      '40': 'ที่อยู่ที่ติดต่อได้',
      '50': 'รหัสไปรษณีย์',
      '60': 'โทรศัพท์',
      '70': 'E-mail Address',
      '80': 'โทรสาร'
    },
    'HRRC21P17': {
      '0': 'ข้อมูลเพิ่มเติม',
      '10': 'รายการข้อมูล',
      '20': 'รายละเอียด',
      '30': 'ประเภทข้อมูล',
      '40': 'ค่าข้อมูล',
      '50': 'แก้ไขครั้งสุดท้าย',
      '60': 'โดย'
    },
    'HRRC21P18': {
      '0': 'รายละเอียดพนักงานในบัญชีดำ',
      '10': 'เลขที่บัตรประชาชน',
      '20': 'คำนำหน้าชื่อ',
      '30': 'ชื่อ',
      '40': 'นามสกุล',
      '50': 'เพศ',
      '60': 'รหัสพนักงานเดิม',
      '70': 'เลขที่ใบสมัคร',
      '80': 'วันเกิด',
      '90': 'อายุ',
      '100': 'ปี',
      '110': 'เดือน',
      '120': 'เลขที่หนังสือเดินทาง',
      '130': 'รูปภาพ',
      '140': 'รายละเอียดการจ้างงาน',
      '150': 'ชื่อสถานประกอบการ',
      '160': 'หน่วยงานสุดท้าย',
      '170': 'ตำแหน่งสุดท้าย',
      '180': 'วันที่เข้างาน',
      '190': 'วันที่ลาออก',
      '200': 'เหตุผลการออกจากงาน'
    },
    'HRRC21P19': {
      '0': 'ความสามารถอื่น ๆ',
      '10': 'กิจกรรมขณะศึกษา',
      '20': 'ความสามารถพิเศษ',
      '30': 'ความสามารถทางคอมพิวเตอร์',
      '40': 'ทักษะทางด้านพิมพ์ดีดภาษาไทย',
      '50': 'คำต่อนาที',
      '60': 'ทักษะทางด้านพิมพ์ดีดภาษาอังกฤษ',
      '70': 'คำต่อนาที',
      '80': 'ความสามารถด้านภาษา',
      '90': 'ฟัง',
      '100': 'พูด',
      '110': 'อ่าน'
    },
    'HRRC21P2': {
      '0': 'สถานะใบสมัคร',
      '10': 'สถานะ',
      '20': 'ณ. วันที่',
      '30': 'อ้างอิงใบขออนุมัติ',
      '40': 'ตำแหน่ง',
      '50': 'รหัสพนักงาน',
      '60': 'รายละเอียดการประเมินผล',
      '70': 'ตำแหน่งที่เหมาะสม',
      '80': 'ประเมินโดย',
      '90': 'หน่วยงาน',
      '100': 'วันที่',
      '110': 'สาเหตุการปฏิเสธ',
      '120': 'บันทึกใน Backlist',
      '130': 'ใช่',
      '140': 'ไม่ใช่',
      '150': 'หมายเหตุ',
      '160': 'ใบขออนุมัติที่เหมาะสม'
    },
    'HRRC21P20': {
      '0': 'สัมภาษณ์/ติดตามผล',
      '10': 'ผลการประเมิน/ทดสอบ',
      '20': 'เลขที่ใบขออนุมัติ',
      '30': 'ตำแหน่ง',
      '40': 'วันที่ดำเนินการ',
      '50': 'ผลการประเมิน',
      '60': 'ผู้ประเมิน',
      '70': 'วันที่ประเมินผล',
      '80': 'รายละเอียดการทดสอบ',
      '90': 'ลำดับ',
      '100': 'ประเภทนัดหมาย',
      '110': 'วันที่นัดหมาย',
      '120': 'คะแนนเต็ม',
      '130': 'คะแนน'
    },
    'HRRC21P3': {
      '0': 'ประวัติการสมัคร',
      '10': 'วันที่สมัคร',
      '20': 'สมัครตำแหน่ง',
      '30': 'ตำแหน่งหลัก',
      '40': 'ตำแหน่งรอง',
      '50': 'เลขที่ใบสมัคร',
      '60': 'สถานะใบสมัคร',
      '70': 'เลขที่ใบขออนุมัติ',
      '80': 'ตำแหน่ง',
      '90': 'วันที่ดำเนินการ',
      '100': 'คะแนนที่ได้ %',
      '110': 'ผลการคัดเลือก'
    },
    'HRRC21P4': {
      '0': 'ข้อมูลส่วนตัว',
      '10': 'วันเกิด',
      '20': 'สถานที่เกิด',
      '30': 'เพศ',
      '31': 'ชาย',
      '32': 'หญิง',
      '40': 'เลขที่บัตรประชาชน',
      '50': 'ออกบัตรที่',
      '60': 'วันที่สิ้นสุด',
      '70': 'จังหวัด',
      '80': 'สถานภาพสมรส',
      '90': 'สถานะทหาร',
      '100': 'เลขที่ผู้เสียภาษีอากร',
      '110': 'เลขที่บัตรประกันสังคม',
      '120': 'กลุ่มเลือด',
      '130': 'น้ำหนัก',
      '140': 'ส่วนสูง',
      '150': 'ศาสนา',
      '160': 'เชื้อชาติ',
      '170': 'สัญชาติ',
      '180': 'ใบอนุญาตขับขี่',
      '190': 'เลขที่ใบอนุญาต',
      '200': 'วันสิ้นสุด',
      '210': 'ข้อมูลหนังสือเดินทาง / ใบอนุญาติทำงาน',
      '220': 'เลขที่หนังสือเดินทาง',
      '230': 'วันสิ้นสุด',
      '240': 'ใบอนุญาติทำงานเลขที่',
      '250': 'ออก ณ วันที่',
      '260': 'วันที่หมดอายุ'
    },
    'HRRC21P5': {
      '0': 'ที่อยู่ที่ติดต่อได้',
      '10': 'ที่อยู่ที่ติดต่อได้',
      '20': 'ที่อยู่ที่ติดต่อได้',
      '30': 'ที่อยู่',
      '40': 'ตำบล',
      '50': 'อำเภอ/เขต',
      '60': 'จังหวัด',
      '70': 'ประเทศ',
      '80': 'โทรศัพท์มือถือ',
      '90': 'รหัสไปรษณีย์',
      '100': 'E-mail Address',
      '110': 'ที่อยู่ตามทะเบียนบ้าน',
      '120': 'ที่อยู่',
      '130': 'ตำบล',
      '140': 'อำเภอ/เขต',
      '150': 'จังหวัด',
      '160': 'ประเทศ',
      '170': 'รหัสไปรษณีย์',
      '180': 'ที่อยู่ Email',
      '190': 'โทรศัพท์บ้าน',
      '200': 'โทรศัพท์มือถือ',
      '210': 'โทรศัพท์บ้าน'
    },
    'HRRC21P6': {
      '0': 'ข้อมูลครอบครัว',
      '10': 'ข้อมูลบิดา - มารดา',
      '20': 'ข้อมูลบิดา',
      '30': 'ชื่อ',
      '40': 'สัญชาติ',
      '50': 'ศาสนา',
      '60': 'อาชีพ',
      '70': 'ข้อมูลมารดา',
      '80': 'ชื่อ',
      '90': 'สัญชาติ',
      '100': 'ศาสนา',
      '110': 'อาชีพ',
      '120': 'รายละเอียดคู่สมรส',
      '130': 'ชื่อ',
      '140': 'เลขที่บัตรประชาชน',
      '150': 'อาชีพ',
      '160': 'วันเกิด',
      '170': 'บริษัท'
    },
    'HRRC21P7': {
      '0': 'ข้อมูลการศึกษา',
      '10': 'ลำดับที่',
      '20': 'ระดับการศึกษา',
      '30': 'วุฒิการศึกษา',
      '40': 'คณะ/สาขา',
      '50': 'สถาบัน',
      '60': 'ประเทศ',
      '70': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '80': 'โดย'
    },
    'HRRC21P8': {
      '0': 'ข้อมูลบุตร',
      '10': 'ลำดับที่',
      '20': 'ชื่อบุตร',
      '30': 'วันเกิด',
      '40': 'เพศ',
      '50': 'ระดับการศึกษา',
      '60': 'แก้ไขครั้งสุดท้าย',
      '70': 'โดย'
    },
    'HRRC21P9': {
      '0': 'ประสบการณ์การทำงาน',
      '10': 'ลำดับที่',
      '20': 'ชื่อบริษัท',
      '30': 'สถานที่ทำงาน',
      '40': 'ตำแหน่ง',
      '50': 'วันที่เริ่มต้น',
      '60': 'วันที่ลาออก',
      '70': 'แก้ไขครั้งสุดท้ายเมื่อ',
      '80': 'โดย'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/stdapplinf.js